const W2000 = [
        {
            "id": 1,
            "word": "count",
            "pronunciation": "kaʊnt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 2,
            "word": "scene",
            "pronunciation": "siːn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 3,
            "word": "writer",
            "pronunciation": "ˈɹaɪ.tə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 4,
            "word": "content",
            "pronunciation": "kənˈtɛnt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 5,
            "word": "prevent",
            "pronunciation": "pɹəˈvɛnt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 6,
            "word": "safe",
            "pronunciation": "seɪf",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 7,
            "word": "invite",
            "pronunciation": "ɪnˈvaɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 8,
            "word": "mix",
            "pronunciation": "ˈmɪks",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 9,
            "word": "element",
            "pronunciation": "ˈɛlɪmənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 10,
            "word": "effective",
            "pronunciation": "əˈfɛktɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 11,
            "word": "correct",
            "pronunciation": "kəˈɹɛkt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 12,
            "word": "medical",
            "pronunciation": "ˈmɛdɪkl̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 13,
            "word": "admit",
            "pronunciation": "ədˈmɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 14,
            "word": "beat",
            "pronunciation": "biːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 15,
            "word": "telephone",
            "pronunciation": "ˈtɛləfəʊn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 16,
            "word": "copy",
            "pronunciation": "ˈkɒpi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 17,
            "word": "committee",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 18,
            "word": "aware",
            "pronunciation": "əˈweːɹ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 19,
            "word": "advice",
            "pronunciation": "ədˈvaɪs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 20,
            "word": "handle",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 21,
            "word": "glass",
            "pronunciation": "ɡlɑːs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 22,
            "word": "trial",
            "pronunciation": "ˈtɹaɪəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 23,
            "word": "stress",
            "pronunciation": "stɹɛs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 24,
            "word": "radio",
            "pronunciation": "ˈɹeɪdiˌəʊ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 25,
            "word": "administration",
            "pronunciation": "ədˌmɪnəˈstɹeɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 26,
            "word": "complex",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 27,
            "word": "text",
            "pronunciation": "tɛkst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 28,
            "word": "context",
            "pronunciation": "ˈkɒntɛkst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 29,
            "word": "ride",
            "pronunciation": "ɹaɪd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 30,
            "word": "directly",
            "pronunciation": "daɪˈɹɛk(t)li",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 31,
            "word": "heavy",
            "pronunciation": "ˈhe.vi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 32,
            "word": "remove",
            "pronunciation": "ɹɪˈmuːv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 33,
            "word": "conduct",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 34,
            "word": "equipment",
            "pronunciation": "ɪˈkwɪpmənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 35,
            "word": "otherwise",
            "pronunciation": "ˈʌð.əˌwaɪz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 36,
            "word": "title",
            "pronunciation": "ˈtaɪtl̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 37,
            "word": "extra",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 38,
            "word": "executive",
            "pronunciation": "ɛɡˈzɛkjʊtɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 39,
            "word": "chair",
            "pronunciation": "t͡ʃɛə(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 40,
            "word": "expensive",
            "pronunciation": "ɛkˈspɛnsɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 41,
            "word": "sample",
            "pronunciation": "sæːm.pəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 42,
            "word": "sex",
            "pronunciation": "sɛks",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 43,
            "word": "deliver",
            "pronunciation": "dɪˈlɪvə(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 44,
            "word": "video",
            "pronunciation": "ˈvɪ.di.əʊ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 45,
            "word": "connection",
            "pronunciation": "kəˈnɛkʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 46,
            "word": "primary",
            "pronunciation": "ˈpɹɒeməɹi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 47,
            "word": "weather",
            "pronunciation": "ˈwɛðə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 48,
            "word": "collect",
            "pronunciation": "kəˈlɛkt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 49,
            "word": "inform",
            "pronunciation": "ɪnˈfɔːm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 50,
            "word": "principle",
            "pronunciation": "ˈpɹɪnsəpəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 51,
            "word": "straight",
            "pronunciation": "stɹeɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 52,
            "word": "appeal",
            "pronunciation": "əˈpiːl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 53,
            "word": "highly",
            "pronunciation": "ˈhaɪli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 54,
            "word": "trust",
            "pronunciation": "trʊst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 55,
            "word": "wonderful",
            "pronunciation": "ˈwʌn.də.fl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 56,
            "word": "flat",
            "pronunciation": "flæt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 57,
            "word": "absolutely",
            "pronunciation": "æb.səˈl(j)uːt.lɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 58,
            "word": "flow",
            "pronunciation": "fləʊ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 59,
            "word": "fair",
            "pronunciation": "feː(ə)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 60,
            "word": "additional",
            "pronunciation": "əˈdɪʃənəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 61,
            "word": "responsible",
            "pronunciation": "ɹɪˈspɒnsəbl̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 62,
            "word": "farm",
            "pronunciation": "fɑːɹm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 63,
            "word": "collection",
            "pronunciation": "kəˈlɛkʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 64,
            "word": "hang",
            "pronunciation": "[heɪŋ]",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 65,
            "word": "negative",
            "pronunciation": "ˈnɛ(e)ɡəˌɾɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 66,
            "word": "band",
            "pronunciation": "bænd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 67,
            "word": "relative",
            "pronunciation": "[ˈɹɛl.ə.tʰɪv]",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 68,
            "word": "tour",
            "pronunciation": "tɔː(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 69,
            "word": "alternative",
            "pronunciation": "ɒl.ˈtɜː(ɹ).nə.tɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 70,
            "word": "software",
            "pronunciation": "ˈsɑftˌwɛɹ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 71,
            "word": "pair",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 72,
            "word": "ship",
            "pronunciation": "ʃɪp",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 73,
            "word": "attitude",
            "pronunciation": "ˈætɪˌtjuːd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 74,
            "word": "cheap",
            "pronunciation": "t͡ʃiːp",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 75,
            "word": "double",
            "pronunciation": "ˈdʌb.əl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 76,
            "word": "leg",
            "pronunciation": "leɪɡ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 77,
            "word": "observe",
            "pronunciation": "əbˈzɝv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 78,
            "word": "sentence",
            "pronunciation": "[ˈsɛntn̩t͡s]",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 79,
            "word": "print",
            "pronunciation": "pɹɪnt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 80,
            "word": "progress",
            "pronunciation": "ˈpɹɒɡɹɛs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 81,
            "word": "truth",
            "pronunciation": "tɹuːθ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 82,
            "word": "nobody",
            "pronunciation": "ˈnəʊ.bɒ.di",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 83,
            "word": "examine",
            "pronunciation": "ɪɡˈzæmɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 84,
            "word": "lay",
            "pronunciation": "leɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 85,
            "word": "speed",
            "pronunciation": "spiːd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 86,
            "word": "politics",
            "pronunciation": "ˈpɒl.ɪ.tɪks",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 87,
            "word": "reply",
            "pronunciation": "ɹɪˈplaɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 88,
            "word": "display",
            "pronunciation": "dɪsˈpleɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 89,
            "word": "transfer",
            "pronunciation": "ˈtɹænzfɜː",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 90,
            "word": "perfect",
            "pronunciation": "ˈpɜː.fɛkt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 91,
            "word": "slightly",
            "pronunciation": "ˈslaɪtli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 92,
            "word": "overall",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 93,
            "word": "intend",
            "pronunciation": "ɪnˈtɛnd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 94,
            "word": "user",
            "pronunciation": "ˈjuːzə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 95,
            "word": "respond",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 96,
            "word": "dinner",
            "pronunciation": "ˈdɪnə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 97,
            "word": "slow",
            "pronunciation": "sləʊ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 98,
            "word": "regular",
            "pronunciation": "ˈɹɛɡjʊlə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 99,
            "word": "physical",
            "pronunciation": "ˈfɪzɪkəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 100,
            "word": "apart",
            "pronunciation": "əˈpɑː(ɹ)t",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 101,
            "word": "suit",
            "pronunciation": "s(j)uːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 102,
            "word": "federal",
            "pronunciation": "ˈfɛdəɹəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 103,
            "word": "reveal",
            "pronunciation": "ɹəˈviːl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 104,
            "word": "percentage",
            "pronunciation": "pəˈsɛntɪd͡ʒ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 105,
            "word": "peace",
            "pronunciation": "piːs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 106,
            "word": "status",
            "pronunciation": "ˈstæt.əs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 107,
            "word": "crime",
            "pronunciation": "kɹaɪm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 108,
            "word": "decline",
            "pronunciation": "dɪˈklaɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 109,
            "word": "decade",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 110,
            "word": "launch",
            "pronunciation": "lɔːnt͡ʃ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 111,
            "word": "warn",
            "pronunciation": "wɔːn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 112,
            "word": "consumer",
            "pronunciation": "kənˈsjuːmə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 113,
            "word": "favor",
            "pronunciation": "ˈfeɪvə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 114,
            "word": "dry",
            "pronunciation": "dɹaɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 115,
            "word": "partner",
            "pronunciation": "ˈpɐːtnə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 116,
            "word": "institution",
            "pronunciation": "ˌɪnstɪˈtjuːʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 117,
            "word": "spot",
            "pronunciation": "spɒt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 118,
            "word": "horse",
            "pronunciation": "hɔːs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 119,
            "word": "eventually",
            "pronunciation": "ɪ.ˈvɛn.tjʊ.li",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 120,
            "word": "heat",
            "pronunciation": "hit",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 121,
            "word": "excite",
            "pronunciation": "ɪkˈsaɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 122,
            "word": "reader",
            "pronunciation": "ˈɹiːdə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 123,
            "word": "importance",
            "pronunciation": "ɪmˈpɔːtəns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 124,
            "word": "distance",
            "pronunciation": "ˈdɪs.təns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 125,
            "word": "guide",
            "pronunciation": "ɡaɪd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 126,
            "word": "grant",
            "pronunciation": "ɡɹɑːnt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 127,
            "word": "taxi",
            "pronunciation": "ˈtæk.si",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 128,
            "word": "feed",
            "pronunciation": "ˈfiːd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 129,
            "word": "pain",
            "pronunciation": "peɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 130,
            "word": "sector",
            "pronunciation": "ˈsɛk.təɹ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 131,
            "word": "mistake",
            "pronunciation": "mɪˈsteɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 132,
            "word": "ensure",
            "pronunciation": "ɪnˈʃɔː",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 133,
            "word": "satisfy",
            "pronunciation": "ˈsætɪsfaɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 134,
            "word": "chief",
            "pronunciation": "tʃiːf",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 135,
            "word": "cool",
            "pronunciation": "kuːl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 136,
            "word": "expert",
            "pronunciation": "ˈɛkspəːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 137,
            "word": "wave",
            "pronunciation": "weɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 138,
            "word": "south",
            "pronunciation": "sæoθ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 139,
            "word": "labor",
            "pronunciation": "ˈleɪ.bɚ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 140,
            "word": "surface",
            "pronunciation": "ˈsɜːfɪs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 141,
            "word": "library",
            "pronunciation": "ˈlaɪbɹi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 142,
            "word": "excellent",
            "pronunciation": "ˈɛksələnt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 143,
            "word": "edge",
            "pronunciation": "ɛdʒ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 144,
            "word": "camp",
            "pronunciation": "[kʰɛəmp]",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 145,
            "word": "audience",
            "pronunciation": "ˈɔːdi.əns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 146,
            "word": "lift",
            "pronunciation": "lɪft",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 147,
            "word": "procedure",
            "pronunciation": "pɹəˈsiːdʒə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 148,
            "word": "email",
            "pronunciation": "ˈiːmeɪl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 149,
            "word": "global",
            "pronunciation": "ˈɡləʊbəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 150,
            "word": "struggle",
            "pronunciation": "ˈstrʌɡəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 151,
            "word": "advertise",
            "pronunciation": "ˈadvə(ɹ)taɪz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 152,
            "word": "select",
            "pronunciation": "sɪˈlɛkt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 153,
            "word": "surround",
            "pronunciation": "səˈɹaʊnd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 154,
            "word": "extent",
            "pronunciation": "ɪksˈtɛnt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 155,
            "word": "river",
            "pronunciation": "ˈɹɪvə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 156,
            "word": "annual",
            "pronunciation": "ˈæn.ju.əl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 157,
            "word": "fully",
            "pronunciation": "ˈfʊli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 158,
            "word": "contrast",
            "pronunciation": "ˈkɒntɹɑːst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 159,
            "word": "roll",
            "pronunciation": "ɹəʊl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 160,
            "word": "reality",
            "pronunciation": "ɹiˈæləti",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 161,
            "word": "photograph",
            "pronunciation": "ˈfəʊ.tə.ˌɡɹɑːf",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 162,
            "word": "artist",
            "pronunciation": "ˈɑːtɪst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 163,
            "word": "conflict",
            "pronunciation": "kənˈflɪkt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 164,
            "word": "entire",
            "pronunciation": "ənˈtaɪə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 165,
            "word": "presence",
            "pronunciation": "ˈpɹɛzəns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 166,
            "word": "crowd",
            "pronunciation": "kɹaʊd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 167,
            "word": "corner",
            "pronunciation": "ˈkɔːnə(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 168,
            "word": "gas",
            "pronunciation": "ɡæs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 169,
            "word": "shift",
            "pronunciation": "ʃɪft",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 170,
            "word": "net",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 171,
            "word": "category",
            "pronunciation": "ˈkætəˌɡɔɹi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 172,
            "word": "secretary",
            "pronunciation": "ˈsɛk.ɹə.tɹi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 173,
            "word": "defense",
            "pronunciation": "dɪˈfɛns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 174,
            "word": "quick",
            "pronunciation": "kwɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 175,
            "word": "cook",
            "pronunciation": "kuːk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 176,
            "word": "spread",
            "pronunciation": "spɹɛd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 177,
            "word": "nuclear",
            "pronunciation": "ˈn(j)ukliɚ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 178,
            "word": "scale",
            "pronunciation": "skeɪl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 179,
            "word": "driver",
            "pronunciation": "ˈdɹaɪ.və(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 180,
            "word": "ball",
            "pronunciation": "bɔːl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 181,
            "word": "cry",
            "pronunciation": "kɹaɪ̯",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 182,
            "word": "introduction",
            "pronunciation": "ˌɪntɹəˈdʌkʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 183,
            "word": "requirement",
            "pronunciation": "ɹɪˈkwʌɪəm(ə)nt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 184,
            "word": "north",
            "pronunciation": "noːθ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 185,
            "word": "confirm",
            "pronunciation": "kənˈfɜːm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 186,
            "word": "senior",
            "pronunciation": "ˈsiːnjə(r)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 187,
            "word": "photo",
            "pronunciation": "ˈfəʊ.təʊ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 188,
            "word": "refuse",
            "pronunciation": "ˈɹɛfjuːs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 189,
            "word": "transport",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 190,
            "word": "emerge",
            "pronunciation": "iˈmɜːd͡ʒ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 191,
            "word": "map",
            "pronunciation": "mæp",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 192,
            "word": "concept",
            "pronunciation": "ˈkɒn.sɛpt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 193,
            "word": "island",
            "pronunciation": "ˈaɪ̯lənd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 194,
            "word": "reform",
            "pronunciation": "ɹɪˈfɔːm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 195,
            "word": "neither",
            "pronunciation": "ˈnaɪð.ə(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 196,
            "word": "football",
            "pronunciation": "[fʷʊʔt̚bɑɫ]",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 197,
            "word": "survive",
            "pronunciation": "səˈvʌɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 198,
            "word": "flight",
            "pronunciation": "flaɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 199,
            "word": "left",
            "pronunciation": "lɛft",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 200,
            "word": "solve",
            "pronunciation": "sɒlv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 201,
            "word": "neighbor",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 202,
            "word": "background",
            "pronunciation": "ˈbæk.ɡɹaʊnd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 203,
            "word": "technique",
            "pronunciation": "tɛkˈniːk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 204,
            "word": "traffic",
            "pronunciation": "ˈtɹæfɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 205,
            "word": "improvement",
            "pronunciation": "ɪmˈpɹuːvmənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 206,
            "word": "tool",
            "pronunciation": "tuːl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 207,
            "word": "consequence",
            "pronunciation": "ˈkɒnsɪkwɛns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 208,
            "word": "circumstance",
            "pronunciation": "-æns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 209,
            "word": "smoke",
            "pronunciation": "sməʊk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 210,
            "word": "reaction",
            "pronunciation": "ɹiˈækʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 211,
            "word": "rain",
            "pronunciation": "ɹeɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 212,
            "word": "busy",
            "pronunciation": "ˈbɪzi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 213,
            "word": "lesson",
            "pronunciation": "ˈlɛsn̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 214,
            "word": "brain",
            "pronunciation": "bɹeɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 215,
            "word": "mass",
            "pronunciation": "mæs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 216,
            "word": "funny",
            "pronunciation": "ˈfʊnɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 217,
            "word": "contribute",
            "pronunciation": "kənˈt(ʃ)ɹɪb.juːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 218,
            "word": "failure",
            "pronunciation": "ˈfeɪl.jɚ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 219,
            "word": "schedule",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 220,
            "word": "speaker",
            "pronunciation": "ˈspiːkə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 221,
            "word": "bottom",
            "pronunciation": "ˈbɒtəm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 222,
            "word": "adopt",
            "pronunciation": "əˈdɒpt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 223,
            "word": "combine",
            "pronunciation": "kəmˈbaɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 224,
            "word": "mountain",
            "pronunciation": "ˈmaʊntɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 225,
            "word": "waste",
            "pronunciation": "weɪst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 226,
            "word": "hide",
            "pronunciation": "haɪd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 227,
            "word": "marriage",
            "pronunciation": "ˈmæɹɪdʒ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 228,
            "word": "ticket",
            "pronunciation": "ˈtɪkɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 229,
            "word": "meal",
            "pronunciation": "miːl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 230,
            "word": "colleague",
            "pronunciation": "ˈkɒliːɡ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 231,
            "word": "bag",
            "pronunciation": "ˈbæːɡ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 232,
            "word": "repeat",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 233,
            "word": "equal",
            "pronunciation": "ˈiːkwəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 234,
            "word": "expression",
            "pronunciation": "ɪkˈspɹɛʃ.ən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 235,
            "word": "plus",
            "pronunciation": "plʌs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 236,
            "word": "extremely",
            "pronunciation": "ɪksˈtɹiːmli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 237,
            "word": "owner",
            "pronunciation": "ˈəʊnə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 238,
            "word": "plane",
            "pronunciation": "pleɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 239,
            "word": "commercial",
            "pronunciation": "kəˈmɜːʃəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 240,
            "word": "lady",
            "pronunciation": "ˈleɪdi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 241,
            "word": "duty",
            "pronunciation": "ˈdjuːti",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 242,
            "word": "strength",
            "pronunciation": "stɹɛŋkθ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 243,
            "word": "connect",
            "pronunciation": "kəˈnɛkt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 244,
            "word": "cultural",
            "pronunciation": "ˈkʌlt͡ʃəɹəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 245,
            "word": "arrange",
            "pronunciation": "əˈɹeɪndʒ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 246,
            "word": "scheme",
            "pronunciation": "skiːm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 247,
            "word": "payment",
            "pronunciation": "ˈpeɪmənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 248,
            "word": "unfortunately",
            "pronunciation": "ʌnˈfɔːtjʊnətli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 249,
            "word": "brief",
            "pronunciation": "bɹiːf",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 250,
            "word": "bird",
            "pronunciation": "bɜd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 251,
            "word": "demonstrate",
            "pronunciation": "ˈdɛmənstɹeɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 252,
            "word": "contribution",
            "pronunciation": "ˌkɒntɹɪˈbjuːʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 253,
            "word": "appreciate",
            "pronunciation": "əˈpɹiː.si.eɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 254,
            "word": "chapter",
            "pronunciation": "ˈt͡ʃæptə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 255,
            "word": "secret",
            "pronunciation": "ˈsiːkɹət",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 256,
            "word": "apparently",
            "pronunciation": "əˈpaɹəntli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 257,
            "word": "novel",
            "pronunciation": "ˈnɒvl̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 258,
            "word": "union",
            "pronunciation": "ˈjuːnjən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 259,
            "word": "burn",
            "pronunciation": "bɜːn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 260,
            "word": "trend",
            "pronunciation": "tɹɛnd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 261,
            "word": "initial",
            "pronunciation": "ɪˈnɪʃəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 262,
            "word": "pleasure",
            "pronunciation": "ˈplɛʒə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 263,
            "word": "suggestion",
            "pronunciation": "səˈd͡ʒɛstjən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 264,
            "word": "critical",
            "pronunciation": "ˈkɹɪtɪkəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 265,
            "word": "gather",
            "pronunciation": "ˈɡæðə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 266,
            "word": "mostly",
            "pronunciation": "ˈməʊstli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 267,
            "word": "earth",
            "pronunciation": "ɜːθ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 268,
            "word": "pop",
            "pronunciation": "pɒp",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 269,
            "word": "essential",
            "pronunciation": "ɪˈsɛn.ʃəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 270,
            "word": "desire",
            "pronunciation": "dɪˈzaɪə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 271,
            "word": "promote",
            "pronunciation": "pɹəˈməʊt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 272,
            "word": "currently",
            "pronunciation": "ˈkʌɹəntli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 273,
            "word": "employ",
            "pronunciation": "ɛmˈplɔɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 274,
            "word": "path",
            "pronunciation": "[pʰäːθ]",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 275,
            "word": "topic",
            "pronunciation": "ˈtɒpɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 276,
            "word": "beach",
            "pronunciation": "biːt͡ʃ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 277,
            "word": "attract",
            "pronunciation": "əˈtɹækt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 278,
            "word": "engage",
            "pronunciation": "ɛnˈɡeɪdʒ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 279,
            "word": "powerful",
            "pronunciation": "ˈpaʊəfl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 280,
            "word": "flower",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 281,
            "word": "crisis",
            "pronunciation": "ˈkɹaɪsɪs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 282,
            "word": "settle",
            "pronunciation": "ˈsɛtəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 283,
            "word": "boat",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 284,
            "word": "aid",
            "pronunciation": "eɪd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 285,
            "word": "fan",
            "pronunciation": "fæn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 286,
            "word": "kitchen",
            "pronunciation": "ˈkɪt͡ʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 287,
            "word": "twice",
            "pronunciation": "twaɪs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 288,
            "word": "fresh",
            "pronunciation": "fɹɛʃ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 289,
            "word": "delay",
            "pronunciation": "dɪˈleɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 290,
            "word": "safety",
            "pronunciation": "ˈseɪfti",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 291,
            "word": "engineer",
            "pronunciation": "ˌɛnd͡ʒɪˈnɪə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 292,
            "word": "quiet",
            "pronunciation": "ˈkwaɪ.ət",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 293,
            "word": "insurance",
            "pronunciation": "ɪn.ˈʃɔː.ɹəns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 294,
            "word": "nurse",
            "pronunciation": "nɜːs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 295,
            "word": "divide",
            "pronunciation": "dɪˈvaɪd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 296,
            "word": "length",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 297,
            "word": "investigation",
            "pronunciation": "ɪnˌvɛstəˈɡeɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 298,
            "word": "package",
            "pronunciation": "ˈpækɪdʒ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 299,
            "word": "somewhere",
            "pronunciation": "ˈsʌm.hweːɹ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 300,
            "word": "expand",
            "pronunciation": "ɛkˈspænd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 301,
            "word": "commit",
            "pronunciation": "kəˈmɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 302,
            "word": "obvious",
            "pronunciation": "ˈɒ.vɪəs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 303,
            "word": "jump",
            "pronunciation": "dʒʌmp",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 304,
            "word": "weapon",
            "pronunciation": "ˈwɛ.pən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 305,
            "word": "relatively",
            "pronunciation": "[ˈɹɛl.ə.tʰɪv.li]",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 306,
            "word": "host",
            "pronunciation": "həʊst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 307,
            "word": "winter",
            "pronunciation": "ˈwɪntɚ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 308,
            "word": "district",
            "pronunciation": "ˈdɪstɹɪkt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 309,
            "word": "broad",
            "pronunciation": "bɹɑd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 310,
            "word": "tire",
            "pronunciation": "ˈtʌɪ̯ɚ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 311,
            "word": "spring",
            "pronunciation": "spɹɪŋ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 312,
            "word": "spirit",
            "pronunciation": "ˈspɪɹɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 313,
            "word": "lunch",
            "pronunciation": "lʌnt͡ʃ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 314,
            "word": "actual",
            "pronunciation": "ˈak(t)ʃj(ʊ)əl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 315,
            "word": "pool",
            "pronunciation": "pul",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 316,
            "word": "battle",
            "pronunciation": "ˈbætəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 317,
            "word": "tradition",
            "pronunciation": "tɹəˈdɪʃn̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 318,
            "word": "cash",
            "pronunciation": "kæʃ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 319,
            "word": "hardly",
            "pronunciation": "ˈhɑːdli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 320,
            "word": "award",
            "pronunciation": "əˈwɔːd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 321,
            "word": "coach",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 322,
            "word": "experiment",
            "pronunciation": "ɛk.ˈspɛ.ɹɪ.mənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 323,
            "word": "consideration",
            "pronunciation": "kənˌsɪdəˈɹeɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 324,
            "word": "strange",
            "pronunciation": "ˈstɹeɪnd͡ʒ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 325,
            "word": "code",
            "pronunciation": "kəʊd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 326,
            "word": "possibly",
            "pronunciation": "ˈpɒsɪbli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 327,
            "word": "threat",
            "pronunciation": "θɹɛt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 328,
            "word": "accident",
            "pronunciation": "ˈæk.sə.dənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 329,
            "word": "impossible",
            "pronunciation": "ɪmˈpɒs.ə.bəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 330,
            "word": "revenue",
            "pronunciation": "ˈɹɛvənjuː",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 331,
            "word": "enable",
            "pronunciation": "ɪˈneɪbəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 332,
            "word": "afraid",
            "pronunciation": "əˈfɹeɪd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 333,
            "word": "active",
            "pronunciation": "ˈæk.tɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 334,
            "word": "conclude",
            "pronunciation": "kən.ˈkluːd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 335,
            "word": "religious",
            "pronunciation": "ɹɪ.ˈlɪ.d͡ʒəs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 336,
            "word": "cancer",
            "pronunciation": "ˈkæːnsə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 337,
            "word": "convince",
            "pronunciation": "kənˈvɪns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 338,
            "word": "vary",
            "pronunciation": "ˈvɛəɹi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 339,
            "word": "environmental",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 340,
            "word": "sun",
            "pronunciation": "sʌn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 341,
            "word": "healthy",
            "pronunciation": "ˈhɛl.θi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 342,
            "word": "blow",
            "pronunciation": "bləʊ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 343,
            "word": "volume",
            "pronunciation": "ˈvɒl.juːm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 344,
            "word": "location",
            "pronunciation": "ləʊˈkeɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 345,
            "word": "invest",
            "pronunciation": "ɪnˈvɛst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 346,
            "word": "proceed",
            "pronunciation": "pɹəˈsiːd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 347,
            "word": "wash",
            "pronunciation": "wɑʃ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 348,
            "word": "actor",
            "pronunciation": "ˈæk.tə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 349,
            "word": "glad",
            "pronunciation": "ɡlæd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 350,
            "word": "tape",
            "pronunciation": "teɪ̯p",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 351,
            "word": "whereas",
            "pronunciation": "weəɹˈæz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 352,
            "word": "opposite",
            "pronunciation": "ˈɒpəsɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 353,
            "word": "stone",
            "pronunciation": "stɐʉn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 354,
            "word": "sum",
            "pronunciation": "sʌm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 355,
            "word": "murder",
            "pronunciation": "ˈmɜːdə(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 356,
            "word": "monitor",
            "pronunciation": "ˈmɒnɨtə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 357,
            "word": "soldier",
            "pronunciation": "ˈsɒld͡ʒə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 358,
            "word": "finance",
            "pronunciation": "faɪˈnæns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 359,
            "word": "hate",
            "pronunciation": "heɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 360,
            "word": "egg",
            "pronunciation": "eɪɡ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 361,
            "word": "concert",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 362,
            "word": "shock",
            "pronunciation": "ʃɒk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 363,
            "word": "comfortable",
            "pronunciation": "ˈkʌm.fə.tə.bəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 364,
            "word": "usual",
            "pronunciation": "ˈjuːʒʊəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 365,
            "word": "carefully",
            "pronunciation": "ˈkɛːfli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 366,
            "word": "pack",
            "pronunciation": "pæk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 367,
            "word": "recall",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 368,
            "word": "wine",
            "pronunciation": "waɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 369,
            "word": "camera",
            "pronunciation": "ˈkæməɹə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 370,
            "word": "swim",
            "pronunciation": "swɪm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 371,
            "word": "manufacture",
            "pronunciation": "ˌmænjʊˈfæktʃə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 372,
            "word": "theater",
            "pronunciation": "ˈθi(ə)tɚ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 373,
            "word": "cycle",
            "pronunciation": "ˈsaɪkəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 374,
            "word": "coffee",
            "pronunciation": "ˈkɑ.fi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 375,
            "word": "totally",
            "pronunciation": "ˈtoʊt.əl.i",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 376,
            "word": "museum",
            "pronunciation": "mjuːˈziːəm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 377,
            "word": "visitor",
            "pronunciation": "ˈvɪzɪtə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 378,
            "word": "freedom",
            "pronunciation": "ˈfɹiːdəm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 379,
            "word": "construction",
            "pronunciation": "kənˈstɹʌkʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 380,
            "word": "dear",
            "pronunciation": "diːɹ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 381,
            "word": "objective",
            "pronunciation": "ɒbˈd͡ʒɛk.tɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 382,
            "word": "moreover",
            "pronunciation": "mɔːˈɹəʊvə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 383,
            "word": "onto",
            "pronunciation": "ˈɒn.tuː",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 384,
            "word": "historical",
            "pronunciation": "hɪˈstɒɹɪkəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 385,
            "word": "oppose",
            "pronunciation": "əˈpəʊz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 386,
            "word": "branch",
            "pronunciation": "bɹæntʃ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 387,
            "word": "vehicle",
            "pronunciation": "ˈvɪː(ə).kəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 388,
            "word": "scientist",
            "pronunciation": "ˈsaɪ.ən.tɪst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 389,
            "word": "route",
            "pronunciation": "ɹʉːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 390,
            "word": "bind",
            "pronunciation": "baɪnd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 391,
            "word": "belong",
            "pronunciation": "bɪˈlɒŋ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 392,
            "word": "taste",
            "pronunciation": "teɪst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 393,
            "word": "tonight",
            "pronunciation": "təˈnaɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 394,
            "word": "fashion",
            "pronunciation": "ˈfæʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 395,
            "word": "danger",
            "pronunciation": "ˈdeɪn.dʒə(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 396,
            "word": "bomb",
            "pronunciation": "bɒm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 397,
            "word": "army",
            "pronunciation": "ˈɑː.miː",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 398,
            "word": "dangerous",
            "pronunciation": "ˈdeɪnd͡ʒ(ə)ɹəs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 399,
            "word": "decrease",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 400,
            "word": "hurt",
            "pronunciation": "hɜːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 401,
            "word": "council",
            "pronunciation": "ˈkaʊn.səl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 402,
            "word": "editor",
            "pronunciation": "ˈɛdɪtə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 403,
            "word": "normally",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 404,
            "word": "sight",
            "pronunciation": "saɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 405,
            "word": "generate",
            "pronunciation": "ˈdʒɛn.əɹ.eɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 406,
            "word": "gift",
            "pronunciation": "ɡɪft",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 407,
            "word": "delivery",
            "pronunciation": "dɪˈlɪv(ə)ɹi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 408,
            "word": "deny",
            "pronunciation": "dɪˈnaɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 409,
            "word": "guest",
            "pronunciation": "ɡɛst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 410,
            "word": "anybody",
            "pronunciation": "ˈɛn.i.bɒd.i",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 411,
            "word": "bedroom",
            "pronunciation": "ˈbɛdɹʊm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 412,
            "word": "quote",
            "pronunciation": "kwəʊt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 413,
            "word": "climb",
            "pronunciation": "klaɪm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 414,
            "word": "basically",
            "pronunciation": "ˈbeɪsɪk(ə)li",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 415,
            "word": "violence",
            "pronunciation": "ˈvaɪləns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 416,
            "word": "minister",
            "pronunciation": "ˈmɪnɪstə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 417,
            "word": "mainly",
            "pronunciation": "ˈmeɪnli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 418,
            "word": "mouth",
            "pronunciation": "mʌʊθ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 419,
            "word": "noise",
            "pronunciation": "nɔɪz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 420,
            "word": "manner",
            "pronunciation": "ˈmænə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 421,
            "word": "gun",
            "pronunciation": "ɡʌn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 422,
            "word": "square",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 423,
            "word": "occasion",
            "pronunciation": "əˈkeɪʒən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 424,
            "word": "familiar",
            "pronunciation": "fəˈmɪl.i.ə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 425,
            "word": "ignore",
            "pronunciation": "ɪɡˈnɔː",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 426,
            "word": "destroy",
            "pronunciation": "dɪˈstɹɔɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 427,
            "word": "affair",
            "pronunciation": "əˈfɛə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 428,
            "word": "civil",
            "pronunciation": "ˈsɪv.əl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 429,
            "word": "locate",
            "pronunciation": "ləʊˈkeɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 430,
            "word": "citizen",
            "pronunciation": "ˈsɪtɪzən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 431,
            "word": "temperature",
            "pronunciation": "ˈtɛmp(ə)ɹətʃə(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 432,
            "word": "gold",
            "pronunciation": "ɡɒʊld",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 433,
            "word": "domestic",
            "pronunciation": "dəˈmɛstɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 434,
            "word": "load",
            "pronunciation": "ləʊd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 435,
            "word": "belief",
            "pronunciation": "bəˈliːf",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 436,
            "word": "troop",
            "pronunciation": "tɹuːp",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 437,
            "word": "technical",
            "pronunciation": "ˈtɛk.nɪk.əl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 438,
            "word": "remind",
            "pronunciation": "ɹəˈmaɪnd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 439,
            "word": "arrangement",
            "pronunciation": "əˈɹeɪnd͡ʒmənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 440,
            "word": "skin",
            "pronunciation": "skɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 441,
            "word": "prison",
            "pronunciation": "ˈpɹɪzən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 442,
            "word": "switch",
            "pronunciation": "swɪtʃ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 443,
            "word": "acquire",
            "pronunciation": "əˈkwaɪə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 444,
            "word": "corporate",
            "pronunciation": "ˈkɔːp(ə)ɹət",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 445,
            "word": "fairly",
            "pronunciation": "ˈfɛə(ɹ).li",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 446,
            "word": "wood",
            "pronunciation": "wʊd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 447,
            "word": "participate",
            "pronunciation": "pɑːˈtɪsɪpeɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 448,
            "word": "tough",
            "pronunciation": "tʌf",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 449,
            "word": "tear",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 450,
            "word": "representative",
            "pronunciation": "ˌɹɛpɹɪˈzɛnt(ət)ɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 451,
            "word": "capacity",
            "pronunciation": "kəˈpæsɪti",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 452,
            "word": "border",
            "pronunciation": "ˈbɔədə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 453,
            "word": "shake",
            "pronunciation": "ˈʃeɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 454,
            "word": "assessment",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 455,
            "word": "shoe",
            "pronunciation": "ʃuː",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 456,
            "word": "ought",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 457,
            "word": "ad",
            "pronunciation": "æd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 458,
            "word": "fee",
            "pronunciation": "fiː",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 459,
            "word": "hall",
            "pronunciation": "hɔːl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 460,
            "word": "regulation",
            "pronunciation": "ˌɹɛɡjʊˈleɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 461,
            "word": "escape",
            "pronunciation": "əˈskeɪp",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 462,
            "word": "studio",
            "pronunciation": "ˈstjuːdiəʊ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 463,
            "word": "proper",
            "pronunciation": "ˈpɹɔp.ə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 464,
            "word": "relax",
            "pronunciation": "ɹɪˈlæks",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 465,
            "word": "tourist",
            "pronunciation": "ˈtʊəɹɪst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 466,
            "word": "component",
            "pronunciation": "kʌmˈpoʊnənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 467,
            "word": "afford",
            "pronunciation": "əˈfɔːd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 468,
            "word": "lawyer",
            "pronunciation": "ˈlɔɪ.ə(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 469,
            "word": "suspect",
            "pronunciation": "ˈsʌs.pɛkt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 470,
            "word": "cup",
            "pronunciation": "kʌp",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 471,
            "word": "description",
            "pronunciation": "dɪˈskɹɪpʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 472,
            "word": "confidence",
            "pronunciation": "ˈkɒnfɪdəns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 473,
            "word": "industrial",
            "pronunciation": "ɪnˈdʌstɹɪəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 474,
            "word": "complain",
            "pronunciation": "kəmˈpleɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 475,
            "word": "perspective",
            "pronunciation": "pɚˈspɛktɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 476,
            "word": "error",
            "pronunciation": "ˈɛɹə(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 477,
            "word": "arrest",
            "pronunciation": "əˈɹɛst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 478,
            "word": "assess",
            "pronunciation": "əˈsɛs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 479,
            "word": "register",
            "pronunciation": "ˈɹɛdʒ.ɪs.tə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 480,
            "word": "asset",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 481,
            "word": "signal",
            "pronunciation": "ˈsɪɡnəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 482,
            "word": "finger",
            "pronunciation": "ˈfɪŋəɹ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 483,
            "word": "relevant",
            "pronunciation": "ˈɹɛləvənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 484,
            "word": "explore",
            "pronunciation": "ɪkˈsplɔː",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 485,
            "word": "leadership",
            "pronunciation": "ˈliːdəʃɪp",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 486,
            "word": "commitment",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 487,
            "word": "wake",
            "pronunciation": "ˈweɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 488,
            "word": "necessarily",
            "pronunciation": "ˌnɛsəˈsɛɹəli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 489,
            "word": "bright",
            "pronunciation": "bɹaɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 490,
            "word": "frame",
            "pronunciation": "fɹeɪm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 491,
            "word": "slowly",
            "pronunciation": "ˈsləʊli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 492,
            "word": "bond",
            "pronunciation": "bɒnd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 493,
            "word": "hire",
            "pronunciation": "haɪə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 494,
            "word": "hole",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 495,
            "word": "tie",
            "pronunciation": "taɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 496,
            "word": "internal",
            "pronunciation": "ɪnˈtɝnəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 497,
            "word": "chain",
            "pronunciation": "ˈt͡ʃeɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 498,
            "word": "literature",
            "pronunciation": "ˈlɪ.tə.ɹɪ.tʃə(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 499,
            "word": "victim",
            "pronunciation": "ˈvɪktəm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 500,
            "word": "threaten",
            "pronunciation": "ˈθɹɛt.n̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 501,
            "word": "division",
            "pronunciation": "dɪˈvɪʒən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 502,
            "word": "secure",
            "pronunciation": "səˈkjɔː(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 503,
            "word": "amaze",
            "pronunciation": "əˈmeɪz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 504,
            "word": "device",
            "pronunciation": "dəˈvaɪs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 505,
            "word": "birth",
            "pronunciation": "bɜːθ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 506,
            "word": "forest",
            "pronunciation": "ˈfɒɹɪst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 507,
            "word": "label",
            "pronunciation": "ˈleɪbəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 508,
            "word": "root",
            "pronunciation": "ɹuːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 509,
            "word": "factory",
            "pronunciation": "ˈfæktəɹi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 510,
            "word": "expense",
            "pronunciation": "ɪkˈspɛns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 511,
            "word": "channel",
            "pronunciation": "ˈtʃænəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 512,
            "word": "investigate",
            "pronunciation": "[ɪn.ˈves.tɪ.ɡeɪ̯t]",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 513,
            "word": "recommendation",
            "pronunciation": "ˌɹɛkəmənˈdeɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 514,
            "word": "rank",
            "pronunciation": "ɹæŋk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 515,
            "word": "typical",
            "pronunciation": "ˈtɪpɪkl̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 516,
            "word": "west",
            "pronunciation": "wɛst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 517,
            "word": "friendly",
            "pronunciation": "ˈfɹɛndli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 518,
            "word": "resident",
            "pronunciation": "ˈɹɛzɪd(ə)nt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 519,
            "word": "provision",
            "pronunciation": "pɹəˈvɪʒ.ən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 520,
            "word": "concentrate",
            "pronunciation": "ˈkɒn.sən.tɹeɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 521,
            "word": "plenty",
            "pronunciation": "ˈplɛnti",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 522,
            "word": "export",
            "pronunciation": "ˈɛks.pɔːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 523,
            "word": "entirely",
            "pronunciation": "ɪnˈtaɪəli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 524,
            "word": "strongly",
            "pronunciation": "stɹɑŋli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 525,
            "word": "bridge",
            "pronunciation": "bɹɪd͡ʒ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 526,
            "word": "consist",
            "pronunciation": "kənˈsɪst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 527,
            "word": "graduate",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 528,
            "word": "brand",
            "pronunciation": "bɹand",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 529,
            "word": "moral",
            "pronunciation": "ˈmɒɹəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 530,
            "word": "insist",
            "pronunciation": "ɪnˈsɪst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 531,
            "word": "combination",
            "pronunciation": "kɒmbɪˈneɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 532,
            "word": "abuse",
            "pronunciation": "əˈbjuːs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 533,
            "word": "ice",
            "pronunciation": "[ʌɪs]",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 534,
            "word": "principal",
            "pronunciation": "ˈpɹɪnsəpəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 535,
            "word": "master",
            "pronunciation": "ˈmastə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 536,
            "word": "definitely",
            "pronunciation": "ˈdɛf.nɪt.li",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 537,
            "word": "session",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 538,
            "word": "grade",
            "pronunciation": "ɡɹeɪd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 539,
            "word": "nevertheless",
            "pronunciation": "ˈnɛvəðəlɛs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 540,
            "word": "predict",
            "pronunciation": "pɹɪˈdɪkt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 541,
            "word": "previously",
            "pronunciation": "ˈpɹiːvi.əsli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 542,
            "word": "protection",
            "pronunciation": "pɹəˈtɛkʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 543,
            "word": "largely",
            "pronunciation": "[ˈlaːdʒ.li]",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 544,
            "word": "wed",
            "pronunciation": "ˈwɛd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 545,
            "word": "rent",
            "pronunciation": "ɹɛnt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 546,
            "word": "shot",
            "pronunciation": "ʃɒt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 547,
            "word": "appearance",
            "pronunciation": "əˈpɪəɹəns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 548,
            "word": "reasonable",
            "pronunciation": "ˈɹiː.zən.ə.bəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 549,
            "word": "guarantee",
            "pronunciation": "ˌɡæɹənˈtiː",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 550,
            "word": "till",
            "pronunciation": "tɪl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 551,
            "word": "theme",
            "pronunciation": "θiːm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 552,
            "word": "judgment",
            "pronunciation": "ˈdʒʌdʒ.mənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 553,
            "word": "odd",
            "pronunciation": "ɒd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 554,
            "word": "approve",
            "pronunciation": "əˈpɹuːv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 555,
            "word": "loan",
            "pronunciation": "ləʊn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 556,
            "word": "definition",
            "pronunciation": "ˌdɛfɪˈnɪʃ(ə)n",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 557,
            "word": "elect",
            "pronunciation": "iːˈlɛkt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 558,
            "word": "atmosphere",
            "pronunciation": "ˈæt.məsˌfɪə(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 559,
            "word": "farmer",
            "pronunciation": "fɑːmə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 560,
            "word": "comparison",
            "pronunciation": "kəmˈpæɹɪsən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 561,
            "word": "characteristic",
            "pronunciation": "ˌkæɹəktəˈɹɪstɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 562,
            "word": "license",
            "pronunciation": "ˈlaɪsəns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 563,
            "word": "rely",
            "pronunciation": "ɹɪˈlaɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 564,
            "word": "narrow",
            "pronunciation": "ˈnæɹəʊ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 565,
            "word": "succeed",
            "pronunciation": "səkˈsiːd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 566,
            "word": "identity",
            "pronunciation": "aɪˈdɛntəti",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 567,
            "word": "desk",
            "pronunciation": "dɛsk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 568,
            "word": "permit",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 569,
            "word": "seriously",
            "pronunciation": "ˈsɪəɹi.əsli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 570,
            "word": "wild",
            "pronunciation": "waɪld",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 571,
            "word": "empty",
            "pronunciation": "ˈɛmpti",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 572,
            "word": "commission",
            "pronunciation": "kəˈmɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 573,
            "word": "unique",
            "pronunciation": "juːˈniːk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 574,
            "word": "association",
            "pronunciation": "əˌsəʊsiˈeɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 575,
            "word": "instrument",
            "pronunciation": "ˈɪnstɹəmənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 576,
            "word": "investor",
            "pronunciation": "ɪnˈvɛstɚ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 577,
            "word": "practical",
            "pronunciation": "ˈpɹæktɪkəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 578,
            "word": "tea",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 579,
            "word": "lovely",
            "pronunciation": "ˈlʌvli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 580,
            "word": "soft",
            "pronunciation": "sɑft",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 581,
            "word": "row",
            "pronunciation": "ˈɹəʊ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 582,
            "word": "youth",
            "pronunciation": "juθ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 583,
            "word": "lock",
            "pronunciation": "lɒk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 584,
            "word": "fuel",
            "pronunciation": "ˈfjuːl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 585,
            "word": "expectation",
            "pronunciation": "ɛkspɛkˈteɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 586,
            "word": "employment",
            "pronunciation": "ɛmˈplɔɪmənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 587,
            "word": "celebrate",
            "pronunciation": "ˈsɛl.ə.bɹeɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 588,
            "word": "sexual",
            "pronunciation": "ˈsɛksjuəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 589,
            "word": "shoulder",
            "pronunciation": "ˈʃəʊldə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 590,
            "word": "breath",
            "pronunciation": "bɹɛθ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 591,
            "word": "increasingly",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 592,
            "word": "import",
            "pronunciation": "ˈɪm.pɔːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 593,
            "word": "bottle",
            "pronunciation": "ˈbɑ.təl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 594,
            "word": "ourselves",
            "pronunciation": "aʊəˈsɛlvz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 595,
            "word": "sheet",
            "pronunciation": "ʃiːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 596,
            "word": "engine",
            "pronunciation": "end͡ʒən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 597,
            "word": "cast",
            "pronunciation": "kæst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 598,
            "word": "notion",
            "pronunciation": "ˈnəʊʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 599,
            "word": "conservative",
            "pronunciation": "kənˈsɜːvətɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 600,
            "word": "journey",
            "pronunciation": "ˈd͡ʒɜːni",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 601,
            "word": "opposition",
            "pronunciation": "ɒpəˈzɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 602,
            "word": "relief",
            "pronunciation": "ɹɪˈliːf",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 603,
            "word": "debt",
            "pronunciation": "dɛt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 604,
            "word": "honor",
            "pronunciation": "ˈɒn.ə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 605,
            "word": "outcome",
            "pronunciation": "ˈaʊtkʌm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 606,
            "word": "blame",
            "pronunciation": "bleɪm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 607,
            "word": "explanation",
            "pronunciation": "ˌɛkspləˈneɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 608,
            "word": "arise",
            "pronunciation": "əˈɹaɪz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 609,
            "word": "musical",
            "pronunciation": "ˈmju.zɪ.kəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 610,
            "word": "recover",
            "pronunciation": "ɹɪˈkʌvə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 611,
            "word": "dad",
            "pronunciation": "dæd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 612,
            "word": "stretch",
            "pronunciation": "stɹɛtʃ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 613,
            "word": "declare",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 614,
            "word": "retire",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 615,
            "word": "tiny",
            "pronunciation": "ˈtaɪni",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 616,
            "word": "careful",
            "pronunciation": "ˈkɛːfəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 617,
            "word": "suitable",
            "pronunciation": "ˈsuːtəbl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 618,
            "word": "native",
            "pronunciation": "ˈneɪtɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 619,
            "word": "fruit",
            "pronunciation": "fɹuːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 620,
            "word": "analyze",
            "pronunciation": "ˈæn.ə.laɪz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 621,
            "word": "witness",
            "pronunciation": "ˈwɪtnəs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 622,
            "word": "mail",
            "pronunciation": "meɪ̯l",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 623,
            "word": "terrible",
            "pronunciation": "ˈtɛ.ɹə.bl̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 624,
            "word": "researcher",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 625,
            "word": "ordinary",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 626,
            "word": "selection",
            "pronunciation": "səˈlɛkʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 627,
            "word": "anywhere",
            "pronunciation": "ˈɛn.iː.(h)wɛə(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 628,
            "word": "mental",
            "pronunciation": "ˈmɛntəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 629,
            "word": "participant",
            "pronunciation": "pɑːˈtɪsɪpənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 630,
            "word": "vision",
            "pronunciation": "ˈvɪ.ʒ(ə)n",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 631,
            "word": "personality",
            "pronunciation": "-i",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 632,
            "word": "specifically",
            "pronunciation": "spəˈsɪf.ɪk.li",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 633,
            "word": "fat",
            "pronunciation": "fæt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 634,
            "word": "entry",
            "pronunciation": "ˈɛntɹi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 635,
            "word": "fellow",
            "pronunciation": "ˈfɛləʊ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 636,
            "word": "chemical",
            "pronunciation": "ˈkɛmɪkəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 637,
            "word": "capture",
            "pronunciation": "ˈkæp.t͡ʃə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 638,
            "word": "tip",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 639,
            "word": "discount",
            "pronunciation": "dɪsˈkaʊnt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 640,
            "word": "peak",
            "pronunciation": "piːk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 641,
            "word": "chairman",
            "pronunciation": "ˈtʃɛːmən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 642,
            "word": "proportion",
            "pronunciation": "pɹəˈpɔːʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 643,
            "word": "ear",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 644,
            "word": "disappear",
            "pronunciation": "dɪsəˈpiːɹ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 645,
            "word": "shout",
            "pronunciation": "ʃaʊt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 646,
            "word": "yard",
            "pronunciation": "jɑːd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 647,
            "word": "constant",
            "pronunciation": "ˈkɒnstənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 648,
            "word": "significantly",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 649,
            "word": "hill",
            "pronunciation": "hɪl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 650,
            "word": "considerable",
            "pronunciation": "kənˈsɪdəɹəbl̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 651,
            "word": "instruction",
            "pronunciation": "ɪnˈstɹʌkʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 652,
            "word": "intelligence",
            "pronunciation": "ɪnˈtɛl.ɪ.d͡ʒəns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 653,
            "word": "ideal",
            "pronunciation": "aɪˈdiː.əl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 654,
            "word": "folk",
            "pronunciation": "fəʊk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 655,
            "word": "surely",
            "pronunciation": "ˈʃɔːli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 656,
            "word": "guard",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 657,
            "word": "cat",
            "pronunciation": "kat",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 658,
            "word": "somewhat",
            "pronunciation": "ˈsʌmwɒt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 659,
            "word": "kiss",
            "pronunciation": "kɪs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 660,
            "word": "presentation",
            "pronunciation": "ˌpɹizənˈteɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 661,
            "word": "joint",
            "pronunciation": "dʒɔɪnt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 662,
            "word": "compete",
            "pronunciation": "kəm.ˈpiːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 663,
            "word": "poll",
            "pronunciation": "pɔl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 664,
            "word": "weak",
            "pronunciation": "wiːk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 665,
            "word": "faith",
            "pronunciation": "feɪθ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 666,
            "word": "reduction",
            "pronunciation": "ɹiˈdɑk.ʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 667,
            "word": "reserve",
            "pronunciation": "ɹɪˈzɜːv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 668,
            "word": "complaint",
            "pronunciation": "kəmˈpleɪnt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 669,
            "word": "bore",
            "pronunciation": "bɔː",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 670,
            "word": "mission",
            "pronunciation": "ˈmɪʃn̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 671,
            "word": "somehow",
            "pronunciation": "ˈsʌmhaʊ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 672,
            "word": "tone",
            "pronunciation": "təʊn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 673,
            "word": "neighborhood",
            "pronunciation": "ˈneɪbə.hʊd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 674,
            "word": "passenger",
            "pronunciation": "ˈpæsənd͡ʒə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 675,
            "word": "justice",
            "pronunciation": "ˈdʒʌs.tɪs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 676,
            "word": "phase",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 677,
            "word": "thin",
            "pronunciation": "ˈθɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 678,
            "word": "rush",
            "pronunciation": "ɹʌʃ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 679,
            "word": "formal",
            "pronunciation": "ˈfɔːməl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 680,
            "word": "religion",
            "pronunciation": "ɹɪˈlɪdʒən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 681,
            "word": "employer",
            "pronunciation": "ɛmplɔɪˈə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 682,
            "word": "reject",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 683,
            "word": "latter",
            "pronunciation": "ˈlæt̬.əɹ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 684,
            "word": "plate",
            "pronunciation": "pleɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 685,
            "word": "ban",
            "pronunciation": "bæn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 686,
            "word": "steal",
            "pronunciation": "stiːl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 687,
            "word": "protest",
            "pronunciation": "ˈpɹəʊ.tɛst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 688,
            "word": "index",
            "pronunciation": "ˈɪndɛks",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 689,
            "word": "sad",
            "pronunciation": "sæd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 690,
            "word": "frequently",
            "pronunciation": "ˈfɹiː.kwənt.li",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 691,
            "word": "circle",
            "pronunciation": "ˈsɜɹkəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 692,
            "word": "helpful",
            "pronunciation": "ˈhɛlp.fəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 693,
            "word": "command",
            "pronunciation": "kəˈmɑːnd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 694,
            "word": "attractive",
            "pronunciation": "əˈtɹæktɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 695,
            "word": "sick",
            "pronunciation": "sɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 696,
            "word": "impression",
            "pronunciation": "ɪmˈpɹɛʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 697,
            "word": "unable",
            "pronunciation": "ʌnˈeɪbəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 698,
            "word": "joke",
            "pronunciation": "dʒəʊk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 699,
            "word": "sky",
            "pronunciation": "skaɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 700,
            "word": "column",
            "pronunciation": "ˈkɑljəm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 701,
            "word": "electronic",
            "pronunciation": "ɪˌlɛkˈtɹɒn.ɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 702,
            "word": "impose",
            "pronunciation": "ɪmˈpəʊz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 703,
            "word": "criminal",
            "pronunciation": "ˈkɹɪmənəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 704,
            "word": "besides",
            "pronunciation": "biˈsaɪdz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 705,
            "word": "properly",
            "pronunciation": "ˈpɹɒ.pə.li",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 706,
            "word": "ancient",
            "pronunciation": "ˈeɪn.ʃənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 707,
            "word": "coast",
            "pronunciation": "kəʊst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 708,
            "word": "ill",
            "pronunciation": "ɪl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 709,
            "word": "kick",
            "pronunciation": "kɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 710,
            "word": "closely",
            "pronunciation": "ˈkləʊsliː",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 711,
            "word": "multiple",
            "pronunciation": "ˈmʌltɪpl̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 712,
            "word": "yield",
            "pronunciation": "jiːld",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 713,
            "word": "via",
            "pronunciation": "ˈvaɪə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 714,
            "word": "legislation",
            "pronunciation": "ˌlɛd͡ʒɪsˈleɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 715,
            "word": "county",
            "pronunciation": "ˈkaʊnti",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 716,
            "word": "unlike",
            "pronunciation": "ʌnˈlaɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 717,
            "word": "mobile",
            "pronunciation": "ˈməʊbaɪl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 718,
            "word": "assistant",
            "pronunciation": "əˈsɪstənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 719,
            "word": "implement",
            "pronunciation": "ˈɪmpləmənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 720,
            "word": "chart",
            "pronunciation": "tʃɑːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 721,
            "word": "attach",
            "pronunciation": "əˈtætʃ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 722,
            "word": "hell",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 723,
            "word": "everywhere",
            "pronunciation": "ɛv.ɹi.(h)weə(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 724,
            "word": "advise",
            "pronunciation": "ədˈvaɪz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 725,
            "word": "household",
            "pronunciation": "ˈhaʊshəʊld",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 726,
            "word": "acknowledge",
            "pronunciation": "əkˈnɒ.lɪdʒ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 727,
            "word": "reward",
            "pronunciation": "ɹəˈwɔːd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 728,
            "word": "east",
            "pronunciation": "iːst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 729,
            "word": "hat",
            "pronunciation": "[hat]",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 730,
            "word": "academic",
            "pronunciation": "ˌækəˈdɛmɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 731,
            "word": "voter",
            "pronunciation": "ˈvəʊtə(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 732,
            "word": "meanwhile",
            "pronunciation": "ˈmiːnhwaɪl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 733,
            "word": "furthermore",
            "pronunciation": "ˈfɜː(ɹ).ðə(ɹ).mɔː(ɹ)",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 734,
            "word": "accuse",
            "pronunciation": "əˈkjuːz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 735,
            "word": "scientific",
            "pronunciation": "ˌsaɪənˈtɪfɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 736,
            "word": "wage",
            "pronunciation": "weɪd͡ʒ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 737,
            "word": "absence",
            "pronunciation": "ˈæb.s(ə)n̩s",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 738,
            "word": "construct",
            "pronunciation": "ˈkɒn.stɹʌkt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 739,
            "word": "remark",
            "pronunciation": "ɹɪˈmɑːk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 740,
            "word": "medicine",
            "pronunciation": "ˈmed(ɪ).sn̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 741,
            "word": "professor",
            "pronunciation": "pɹəˈfɛsə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 742,
            "word": "rare",
            "pronunciation": "[ɹɜɹ]",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 743,
            "word": "intention",
            "pronunciation": "ɪnˈtɛnʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 744,
            "word": "dozen",
            "pronunciation": "ˈdʌzən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 745,
            "word": "settlement",
            "pronunciation": "ˈset.l.mənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 746,
            "word": "gap",
            "pronunciation": "ɡæp",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 747,
            "word": "widely",
            "pronunciation": "ˈwaɪdli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 748,
            "word": "minimum",
            "pronunciation": "ˈmɪn.ɪ.məm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 749,
            "word": "northern",
            "pronunciation": "ˈnɔːðn̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 750,
            "word": "estate",
            "pronunciation": "ɪsˈteɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 751,
            "word": "equally",
            "pronunciation": "ˈiːkwəli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 752,
            "word": "expose",
            "pronunciation": "ɪkˈspəʊz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 753,
            "word": "alive",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 754,
            "word": "shut",
            "pronunciation": "ʃʌt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 755,
            "word": "victory",
            "pronunciation": "ˈvɪkt(ə)ɹi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 756,
            "word": "resolve",
            "pronunciation": "ɹiːˈzɒlv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 757,
            "word": "critic",
            "pronunciation": "ˈkɹɪt.ɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 758,
            "word": "variable",
            "pronunciation": "ˈvɛəɹ.i.ə.bl̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 759,
            "word": "enormous",
            "pronunciation": "ɪˈnɔː(ɹ)məs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 760,
            "word": "sweet",
            "pronunciation": "swiːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 761,
            "word": "permanent",
            "pronunciation": "ˈpɜːmənənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 762,
            "word": "emotion",
            "pronunciation": "iˈmoʊʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 763,
            "word": "pursue",
            "pronunciation": "pəˈʃu",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 764,
            "word": "tall",
            "pronunciation": "tɔːl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 765,
            "word": "urge",
            "pronunciation": "ɜːd͡ʒ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 766,
            "word": "enemy",
            "pronunciation": "ˈɛnəmi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 767,
            "word": "appoint",
            "pronunciation": "əˈpɔɪnt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 768,
            "word": "milk",
            "pronunciation": "[mɛlk]",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 769,
            "word": "talent",
            "pronunciation": "ˈtalənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 770,
            "word": "smell",
            "pronunciation": "smɛl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 771,
            "word": "prior",
            "pronunciation": "ˈpɹaɪɚ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 772,
            "word": "priority",
            "pronunciation": "pɹaɪˈɒɹɨti",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 773,
            "word": "online",
            "pronunciation": "ɒnˈlaɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 774,
            "word": "phrase",
            "pronunciation": "fɹeɪz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 775,
            "word": "pilot",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 776,
            "word": "stable",
            "pronunciation": "ˈsteɪ.bəɫ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 777,
            "word": "merely",
            "pronunciation": "ˈmɪəli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 778,
            "word": "resolution",
            "pronunciation": "ˌɹɛzəˈluːʃ(ə)n",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 779,
            "word": "communicate",
            "pronunciation": "kəˈmjuːnɪkeɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 780,
            "word": "injury",
            "pronunciation": "ˈɪn.dʒə.ɹi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 781,
            "word": "vast",
            "pronunciation": "vɑːst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 782,
            "word": "exhibition",
            "pronunciation": "ɛksɪˈbɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 783,
            "word": "producer",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 784,
            "word": "regional",
            "pronunciation": "ˈɹiːdʒnəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 785,
            "word": "immediate",
            "pronunciation": "ɪˈmiːdɪət",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 786,
            "word": "incident",
            "pronunciation": "ˈɪn.sɪ.dənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 787,
            "word": "childhood",
            "pronunciation": "ˈtʃaɪldhʊd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 788,
            "word": "draft",
            "pronunciation": "dɹæft",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 789,
            "word": "slip",
            "pronunciation": "slɪp",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 790,
            "word": "accompany",
            "pronunciation": "ə.ˈkʌm.pə.ni",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 791,
            "word": "politician",
            "pronunciation": "ˈpɒl.ɪ.tɪʃ.ən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 792,
            "word": "angry",
            "pronunciation": "ˈæŋ.ɡɹi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 793,
            "word": "knock",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 794,
            "word": "seed",
            "pronunciation": "siːd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 795,
            "word": "salary",
            "pronunciation": "ˈsælɚi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 796,
            "word": "illustrate",
            "pronunciation": "ɪ.ˈlʌs.tɹeɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 797,
            "word": "imply",
            "pronunciation": "ɪmˈplaɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 798,
            "word": "breakfast",
            "pronunciation": "ˈbɹɛkfəst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 799,
            "word": "temporary",
            "pronunciation": "ˈtɛmpəɹi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 800,
            "word": "liberal",
            "pronunciation": "ˈlɪbɹəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 801,
            "word": "lake",
            "pronunciation": "leɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 802,
            "word": "qualify",
            "pronunciation": "ˈkwɒl.ɪ.faɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 803,
            "word": "competitive",
            "pronunciation": "kəmˈpɛtɪtɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 804,
            "word": "truly",
            "pronunciation": "ˈtɹuːli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 805,
            "word": "hi",
            "pronunciation": "haɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 806,
            "word": "yellow",
            "pronunciation": "jɛlə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 807,
            "word": "habit",
            "pronunciation": "ˈhæbət",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 808,
            "word": "disk",
            "pronunciation": "dɪsk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 809,
            "word": "core",
            "pronunciation": "kɔː",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 810,
            "word": "emotional",
            "pronunciation": "ɪˈməʊʃnəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 811,
            "word": "aircraft",
            "pronunciation": "ɛə.kɹɑːft",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 812,
            "word": "self",
            "pronunciation": "sɛlf",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 813,
            "word": "metal",
            "pronunciation": "ˈmɛtəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 814,
            "word": "existence",
            "pronunciation": "ɛɡ.ˈzɪs.təns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 815,
            "word": "bone",
            "pronunciation": "bəʉn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 816,
            "word": "panel",
            "pronunciation": "ˈpænəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 817,
            "word": "prime",
            "pronunciation": "pɹaɪ̯m",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 818,
            "word": "appointment",
            "pronunciation": "əˈpɔɪnt.mɛnt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 819,
            "word": "emphasize",
            "pronunciation": "ˈɛm.fə.saɪz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 820,
            "word": "maximum",
            "pronunciation": "ˈmæksɪməm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 821,
            "word": "effectively",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 822,
            "word": "elsewhere",
            "pronunciation": "ˌɛlsˈʍɛːə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 823,
            "word": "bother",
            "pronunciation": "[ˈbɔðə(ɹ)]",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 824,
            "word": "initiative",
            "pronunciation": "ɪˈnɪʃətɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 825,
            "word": "sharp",
            "pronunciation": "ʃɑːp",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 826,
            "word": "diet",
            "pronunciation": "ˈdaɪət",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 827,
            "word": "motion",
            "pronunciation": "ˈməʊʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 828,
            "word": "gray",
            "pronunciation": "ɡɹeɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 829,
            "word": "plastic",
            "pronunciation": "ˈplæstɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 830,
            "word": "complicate",
            "pronunciation": "ˈkɒmplɪkeɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 831,
            "word": "discipline",
            "pronunciation": "ˈdɪ.sə.plɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 832,
            "word": "disappoint",
            "pronunciation": "dɪsəˈpɔɪnt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 833,
            "word": "boss",
            "pronunciation": "bɑs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 834,
            "word": "assumption",
            "pronunciation": "əˈsʌmp.ʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 835,
            "word": "freeze",
            "pronunciation": "ˈfɹiːz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 836,
            "word": "extreme",
            "pronunciation": "ɛkˈstɹiːm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 837,
            "word": "passage",
            "pronunciation": "ˈpæsɪd͡ʒ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 838,
            "word": "reputation",
            "pronunciation": "ˌɹɛpjʊˈteɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 839,
            "word": "forth",
            "pronunciation": "fɔːθ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 840,
            "word": "negotiation",
            "pronunciation": "nɪˌɡəʊʃiˈeɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 841,
            "word": "mechanism",
            "pronunciation": "ˈmɛkənɪzm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 842,
            "word": "coat",
            "pronunciation": "kəʊt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 843,
            "word": "democracy",
            "pronunciation": "dɪˈmɒkɹəsi",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 844,
            "word": "pocket",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 845,
            "word": "lucky",
            "pronunciation": "ˈlʌki",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 846,
            "word": "crash",
            "pronunciation": "kɹæʃ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 847,
            "word": "observation",
            "pronunciation": "ˌɒbzəˈveɪʃ(ə)n",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 848,
            "word": "meat",
            "pronunciation": "miːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 849,
            "word": "concentration",
            "pronunciation": "ˌkɒnsənˈtɹeɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 850,
            "word": "implication",
            "pronunciation": "ˌɪmpləˈkeɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 851,
            "word": "deserve",
            "pronunciation": "dɪˈzɜːv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 852,
            "word": "unusual",
            "pronunciation": "ʌnˈjuːʒuəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 853,
            "word": "defend",
            "pronunciation": "dɪˈfɛnd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 854,
            "word": "classic",
            "pronunciation": "ˈklæ.sɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 855,
            "word": "king",
            "pronunciation": "kɪŋ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 856,
            "word": "interaction",
            "pronunciation": "ˌɪntəɹˈækʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 857,
            "word": "repair",
            "pronunciation": "ɹɪˈpɛə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 858,
            "word": "collapse",
            "pronunciation": "kəˈlæps",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 859,
            "word": "borrow",
            "pronunciation": "ˈbɔɹoʊ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 860,
            "word": "fundamental",
            "pronunciation": "ˌfʌndəˈmɛntəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 861,
            "word": "dish",
            "pronunciation": "dɪʃ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 862,
            "word": "abroad",
            "pronunciation": "əˈbɹɔːd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 863,
            "word": "soul",
            "pronunciation": "səʊl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 864,
            "word": "capable",
            "pronunciation": "ˈkeɪpəbl̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 865,
            "word": "defeat",
            "pronunciation": "dɪˈfiːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 866,
            "word": "presidential",
            "pronunciation": "pɹɛzɪˈdɛnʃ(ə)l",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 867,
            "word": "perfectly",
            "pronunciation": "ˈpɜːfɪktli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 868,
            "word": "enhance",
            "pronunciation": "ɪnˈhɑːns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 869,
            "word": "proud",
            "pronunciation": "pɹaʊd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 870,
            "word": "emergency",
            "pronunciation": "ɪˈmɝ.dʒən.si",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 871,
            "word": "educational",
            "pronunciation": "ˌɛdʒʊˈkeɪʃənəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 872,
            "word": "distinguish",
            "pronunciation": "dɪsˈtɪŋɡwɪʃ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 873,
            "word": "substantial",
            "pronunciation": "səbˈstænʃəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 874,
            "word": "nearby",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 875,
            "word": "manufacturer",
            "pronunciation": "ˌmænjuˈfæktʃɚ(ɹ)ɚ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 876,
            "word": "slide",
            "pronunciation": "slaɪd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 877,
            "word": "valuable",
            "pronunciation": "ˈvæljuəbl̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 878,
            "word": "personally",
            "pronunciation": "ˈpɜːsnəli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 879,
            "word": "breast",
            "pronunciation": "bɹɛst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 880,
            "word": "cope",
            "pronunciation": "kəʊp",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 881,
            "word": "approximately",
            "pronunciation": "əˈpɹɒk.sɪ.mət.li",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 882,
            "word": "accommodation",
            "pronunciation": "ə.ˌkɒm.ə.ˈdeɪ.ʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 883,
            "word": "highlight",
            "pronunciation": "ˈhaɪ.ˌlaɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 884,
            "word": "reporter",
            "pronunciation": "ɹɪˈpɔːtə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 885,
            "word": "climate",
            "pronunciation": "ˈklaɪmɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 886,
            "word": "shirt",
            "pronunciation": "ʃɜːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 887,
            "word": "exception",
            "pronunciation": "əkˈsɛpʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 888,
            "word": "corporation",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 889,
            "word": "chip",
            "pronunciation": "tʃɪp",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 890,
            "word": "winner",
            "pronunciation": "ˈwɪnə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 891,
            "word": "encounter",
            "pronunciation": "ɪnˈkaʊntə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 892,
            "word": "brown",
            "pronunciation": "bɹaʊn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 893,
            "word": "breathe",
            "pronunciation": "bɹiːð",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 894,
            "word": "excuse",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 895,
            "word": "partly",
            "pronunciation": "ˈpɑːtli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 896,
            "word": "tennis",
            "pronunciation": "ˈtɛn.ɪs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 897,
            "word": "urban",
            "pronunciation": "ˈɜːbən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 898,
            "word": "confuse",
            "pronunciation": "kənˈfjuːz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 899,
            "word": "southern",
            "pronunciation": "ˈsʌðɚn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 900,
            "word": "output",
            "pronunciation": "ˈaʊtpʊt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 901,
            "word": "beauty",
            "pronunciation": "ˈbuːti",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 902,
            "word": "massive",
            "pronunciation": "ˈmæs.ɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 903,
            "word": "install",
            "pronunciation": "ɪnˈstɔːl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 904,
            "word": "calculate",
            "pronunciation": "ˈkælkjəleɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 905,
            "word": "mouse",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 906,
            "word": "mathematics",
            "pronunciation": "mæθ(ə)ˈmætɪks",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 907,
            "word": "upper",
            "pronunciation": "ˈʌpə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 908,
            "word": "creation",
            "pronunciation": "kɹiːˈeɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 909,
            "word": "occupy",
            "pronunciation": "ˈɒkjʊpaɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 910,
            "word": "outline",
            "pronunciation": "ˈaʊtlaɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 911,
            "word": "sufficient",
            "pronunciation": "səˈfɪʃənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 912,
            "word": "update",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 913,
            "word": "luck",
            "pronunciation": "lʊk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 914,
            "word": "preserve",
            "pronunciation": "pɹəˈzɜːv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 915,
            "word": "split",
            "pronunciation": "splɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 916,
            "word": "swing",
            "pronunciation": "ˈswɪŋ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 917,
            "word": "illness",
            "pronunciation": "ˈɪl.nəs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 918,
            "word": "journalist",
            "pronunciation": "ˈdʒɜːnəlɪst",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 919,
            "word": "sudden",
            "pronunciation": "ˈsʌdən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 920,
            "word": "advertisement",
            "pronunciation": "ədˈvɜːtɪsmənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 921,
            "word": "consistent",
            "pronunciation": "kənˈsɪstənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 922,
            "word": "originally",
            "pronunciation": "əˈɹɪdʒnəli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 923,
            "word": "aside",
            "pronunciation": "əˈsaɪd",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 924,
            "word": "comfort",
            "pronunciation": "ˈkʊm.fət",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 925,
            "word": "secondly",
            "pronunciation": "ˈsɛkəndli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 926,
            "word": "severe",
            "pronunciation": "sɪˈvɪə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 927,
            "word": "gene",
            "pronunciation": "dʒiːn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 928,
            "word": "prospect",
            "pronunciation": "ˈpɹɒspɛkt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 929,
            "word": "snow",
            "pronunciation": "snəʊ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 930,
            "word": "plot",
            "pronunciation": "plɒt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 931,
            "word": "neck",
            "pronunciation": "nɛk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 932,
            "word": "criterion",
            "pronunciation": "kɹaɪˈtɪəɹi.ən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 933,
            "word": "primarily",
            "pronunciation": "pɹaɪˈmɛɹəli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 934,
            "word": "integrate",
            "pronunciation": "ˈɪntəɡɹeɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 935,
            "word": "criticism",
            "pronunciation": "ˈkɹɪtɪsɪzəm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 936,
            "word": "convention",
            "pronunciation": "kənˈvɛn.ʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 937,
            "word": "bet",
            "pronunciation": "ˈbɛt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 938,
            "word": "retain",
            "pronunciation": "ɹɪˈteɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 939,
            "word": "sequence",
            "pronunciation": "ˈsiːkwəns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 940,
            "word": "plain",
            "pronunciation": "pleɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 941,
            "word": "volunteer",
            "pronunciation": "vɒl.ənˈtɪə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 942,
            "word": "rural",
            "pronunciation": "ˈɹɔːɹəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 943,
            "word": "calm",
            "pronunciation": "kam",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 944,
            "word": "abandon",
            "pronunciation": "əˈbæn.dən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 945,
            "word": "examination",
            "pronunciation": "ɪɡˌzæmɪˈneɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 946,
            "word": "silence",
            "pronunciation": "ˈsaɪ.ləns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 947,
            "word": "rapidly",
            "pronunciation": "ˈɹæpɪdli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 948,
            "word": "efficient",
            "pronunciation": "əˈfɪʃənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 949,
            "word": "revolution",
            "pronunciation": "ˌɹɛvəˈl(j)uːʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 950,
            "word": "delight",
            "pronunciation": "dəˈlaɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 951,
            "word": "spell",
            "pronunciation": "spɛl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 952,
            "word": "premise",
            "pronunciation": "ˈpɹɛ.mɪs",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 953,
            "word": "lean",
            "pronunciation": "liːn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 954,
            "word": "dramatic",
            "pronunciation": "dɹəˈmætɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 955,
            "word": "differ",
            "pronunciation": "ˈdɪfə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 956,
            "word": "grateful",
            "pronunciation": "ˈɡɹeɪtfəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 957,
            "word": "protein",
            "pronunciation": "ˈpɹəʊti.ɪn",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 958,
            "word": "bike",
            "pronunciation": "[bɐɪk]",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 959,
            "word": "distribute",
            "pronunciation": "dɨˈstɹɪbjuːt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 960,
            "word": "intellectual",
            "pronunciation": "ˌɪntəˈlɛk(t)ʃʊəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 961,
            "word": "derive",
            "pronunciation": "dəˈɹaɪv",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 962,
            "word": "crucial",
            "pronunciation": "ˈkɹuː.ʃəl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 963,
            "word": "unemployment",
            "pronunciation": "ʌn.ɪmˈplɔɪ.mənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 964,
            "word": "wheel",
            "pronunciation": "ʍiːl",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 965,
            "word": "crop",
            "pronunciation": "kɹɒp",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 966,
            "word": "minority",
            "pronunciation": "maɪˈnɒɹ.ɪ.ti",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 967,
            "word": "origin",
            "pronunciation": "ˈɒɹ.ə.dʒən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 968,
            "word": "interpretation",
            "pronunciation": "ɪntəpɹəˈteɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 969,
            "word": "gentleman",
            "pronunciation": "ˈdʒɛn.təl.mən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 970,
            "word": "drama",
            "pronunciation": "ˈdɹæmə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 971,
            "word": "landscape",
            "pronunciation": "ˈlandskeɪp",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 972,
            "word": "educate",
            "pronunciation": "ˈedʒɘkæet",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 973,
            "word": "toy",
            "pronunciation": "tɔɪ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 974,
            "word": "fault",
            "pronunciation": "fɒlt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 975,
            "word": "exhibit",
            "pronunciation": "ɛɡ-",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 976,
            "word": "minor",
            "pronunciation": "ˈmaɪnɚ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 977,
            "word": "hunt",
            "pronunciation": "hʌnt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 978,
            "word": "storm",
            "pronunciation": "stɔːm",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 979,
            "word": "thick",
            "pronunciation": "θɪk",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 980,
            "word": "achievement",
            "pronunciation": "əˈtʃiːvmənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 981,
            "word": "negotiate",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 982,
            "word": "dominate",
            "pronunciation": "ˈdɒməˌneɪt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 983,
            "word": "supplier",
            "pronunciation": "səˈplaɪə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 984,
            "word": "prize",
            "pronunciation": "pɹaɪz",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 985,
            "word": "typically",
            "pronunciation": "ˈtɪp.ɪ.kl.i",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 986,
            "word": "peer",
            "pronunciation": "pɪə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 987,
            "word": "pension",
            "pronunciation": "ˈpɛnʃ(ə)n",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 988,
            "word": "wing",
            "pronunciation": "wɪŋ",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 989,
            "word": "acquisition",
            "pronunciation": "æ.kwɪ.ˈzɪ.ʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 990,
            "word": "laughter",
            "pronunciation": "ˈlɑːftə",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 991,
            "word": "deeply",
            "pronunciation": "ˈdiːpli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 992,
            "word": "recognition",
            "pronunciation": "ˌɹɛkəɡˈnɪʃən",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 993,
            "word": "electricity",
            "pronunciation": "ɪˌlɛkˈtɹɪsɪti",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 994,
            "word": "assistance",
            "pronunciation": "əˈsɪs.təns",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 995,
            "word": "roof",
            "pronunciation": "ɹuːf",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 996,
            "word": "retirement",
            "pronunciation": "ɹəˈtaɪə(ɹ).mənt",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 997,
            "word": "respectively",
            "pronunciation": "ɹɪˈspɛktɪvli",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 998,
            "word": "variation",
            "pronunciation": "ˌvɛəɹɪˈeɪʃn̩",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 999,
            "word": "ultimately",
            "pronunciation": "ˈʌltɪmətli",
            "progress": [
                0,
                0,
                0
            ]
        }
    ];
    export default W2000;
